export default {
  edit: "template:edit",
  create: "template:create",
  delete: "template:delete",
  view: "template:view",
};
